export type WalletDashboardExecutionMode = "gateway" | "vm_gpu" | string;

export type WalletModelOption = {
  id: string;
  name: string;
  org: string;
  q: number | null;
  s: number | null;
  tag: string | null;
};

export const WALLET_VM_MODEL_OPTIONS: WalletModelOption[] = [
  { id: "deepseek", name: "deepseek-r1-distill-qwen-7b", org: "DeepSeek", q: 96, s: 82, tag: "Best" },
  { id: "mistral", name: "mistral-7b-instruct", org: "Mistral AI", q: 86, s: 94, tag: null },
  { id: "qwen", name: "qwen2.5-7b-instruct", org: "Qwen", q: 85, s: 90, tag: "Fast" },
];

export const WALLET_GATEWAY_MODEL_OPTIONS: WalletModelOption[] = [
  { id: "deepseek/deepseek-chat-v3-0324", name: "deepseek-chat-v3-0324", org: "DeepSeek", q: 94, s: 88, tag: "Gateway" },
  { id: "qwen/qwen-2.5-7b-instruct", name: "qwen2.5-7b-instruct", org: "Qwen", q: 88, s: 94, tag: "Fast" },
  { id: "google/gemma-3-12b-it", name: "gemma-3-12b-it", org: "Google", q: 86, s: 89, tag: null },
];

const VM_DEFAULT_MODEL_ID = "deepseek-ai/DeepSeek-R1-Distill-Qwen-7B";
const GATEWAY_DEFAULT_MODEL_ID = "deepseek/deepseek-chat-v3-0324";

const VM_MODEL_ID_BY_KEY: Record<string, string> = {
  deepseek: VM_DEFAULT_MODEL_ID,
  "deepseek-ai/deepseek-r1-distill-qwen-7b": VM_DEFAULT_MODEL_ID,
  "deepseek/deepseek-chat-v3-0324": VM_DEFAULT_MODEL_ID,
  mistral: "mistralai/Mistral-7B-Instruct-v0.3",
  "mistralai/mistral-7b-instruct-v0.3": "mistralai/Mistral-7B-Instruct-v0.3",
  qwen: "Qwen/Qwen2.5-7B-Instruct",
  "qwen/qwen2.5-7b-instruct": "Qwen/Qwen2.5-7B-Instruct",
  "qwen/qwen-2.5-7b-instruct": "Qwen/Qwen2.5-7B-Instruct",
  "qwen/qwen3-8b": "Qwen/Qwen3-8B",
  gemma: "google/gemma-3-12b-it",
  "google/gemma-3-12b-it": "google/gemma-3-12b-it",
};

const GATEWAY_MODEL_ID_BY_KEY: Record<string, string> = {
  deepseek: GATEWAY_DEFAULT_MODEL_ID,
  "deepseek-ai/deepseek-r1-distill-qwen-7b": GATEWAY_DEFAULT_MODEL_ID,
  "deepseek/deepseek-chat-v3-0324": GATEWAY_DEFAULT_MODEL_ID,
  mistral: GATEWAY_DEFAULT_MODEL_ID,
  "mistralai/mistral-7b-instruct-v0.3": GATEWAY_DEFAULT_MODEL_ID,
  qwen: "qwen/qwen-2.5-7b-instruct",
  "qwen/qwen2.5-7b-instruct": "qwen/qwen-2.5-7b-instruct",
  "qwen/qwen-2.5-7b-instruct": "qwen/qwen-2.5-7b-instruct",
  "qwen/qwen3-8b": "qwen/qwen3-8b",
  "qwen/qwen-3-8b": "qwen/qwen3-8b",
  "qwen/qwen2.5-7b": "qwen/qwen-2.5-7b-instruct",
  gemma: "google/gemma-3-12b-it",
  google: "google/gemma-3-12b-it",
  "google/gemma-3-12b-it": "google/gemma-3-12b-it",
};

function modelKey(value?: string) {
  return String(value || "").trim().toLowerCase();
}

export function walletDashboardModelID(value: string, executionMode?: WalletDashboardExecutionMode) {
  const raw = String(value || "").trim();
  const key = modelKey(raw);
  if (executionMode === "gateway") {
    return GATEWAY_MODEL_ID_BY_KEY[key] || GATEWAY_DEFAULT_MODEL_ID;
  }
  return VM_MODEL_ID_BY_KEY[key] || raw || VM_DEFAULT_MODEL_ID;
}

export function walletGatewayModelIDFromTask(value?: string) {
  const key = modelKey(value);
  if (GATEWAY_MODEL_ID_BY_KEY[key]) return GATEWAY_MODEL_ID_BY_KEY[key];
  if (key.includes("qwen")) return "qwen/qwen-2.5-7b-instruct";
  if (key.includes("gemma") || key.includes("google")) return "google/gemma-3-12b-it";
  return GATEWAY_DEFAULT_MODEL_ID;
}
